module.exports = __webpack_public_path__ + "static/media/Icon-GraphicDesigner.4e3d6d79.png";